import { Wallet } from "lucide-react";
import { useAccount } from "wagmi";
import { ConnectKitButton } from "connectkit";
import { Modal } from "@/components/ui/Modal";
import { Button } from "@/components/ui/Button";
import type { PaymentAccept } from "@/lib/x402";
import { formatAtomicUnits } from "@/lib/x402";
import { useAcceptTokens } from "@/hooks/useAcceptTokens";

interface PaymentModalProps {
  open: boolean;
  onClose: () => void;
  accept: PaymentAccept | null;
  onWalletPay: () => void;
}

export function PaymentModal({
  open,
  onClose,
  accept,
  onWalletPay,
}: PaymentModalProps) {
  const { isConnected } = useAccount();
  const { tokens } = useAcceptTokens(accept ? [accept] : []);
  const acceptToken = tokens?.[0];

  return (
    <Modal open={open} onClose={onClose} title="Pay with wallet">
      <div className="flex flex-col items-center text-center">
        {accept && acceptToken && (
          <p className="text-grey font-body text-sm mb-5">
            {formatAtomicUnits(accept.amount, acceptToken.decimals)} {acceptToken.symbol}
          </p>
        )}

        {isConnected ? (
          <Button
            variant="secondary"
            size="lg"
            className="w-full"
            onClick={onWalletPay}
          >
            <Wallet size={18} className="mr-2" />
            Pay with Wallet
          </Button>
        ) : (
          <ConnectKitButton.Custom>
            {({ show }) => (
              <Button
                variant="secondary"
                size="lg"
                className="w-full"
                onClick={() => { onClose(); show?.(); }}
              >
                <Wallet size={18} className="mr-2" />
                Connect Wallet to Pay
              </Button>
            )}
          </ConnectKitButton.Custom>
        )}
      </div>
    </Modal>
  );
}
